module.exports = __webpack_public_path__ + "static/img/Profile_pic_square_mid.94c4193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Profile_pic_square_mid.png
// module id = 61
// module chunks = 1